import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import DailyTaskContentSheet from "./components/DailyTaskContentSheet";
import DailyTaskReportForm from "./components/DailyTaskReportForm";
import DistrictSelectionForm from "./components/DistrictSelectionForm";
import HomePage from "./components/HomePage";
import LoginScreen from "./components/LoginScreen";
import MissingDailyTasks from "./components/MissingDailyTasks";
import NewLeads from "./components/NewLeads";
import NewMonthlyTaskReportForm from "./components/NewMonthlyTaskReportForm";
import OneTimeTaskReportForm from "./components/OneTimeTaskReportForm";
import ReportDashboard from "./components/ReportDashBoard";
import ReportForms from "./components/ReportForms";
import ReportLoginForm from "./components/ReportLoginFrom";
import ReportSignup from "./components/ReportSignup";
import ShareReferralForm from "./components/shareReferralForm";
import WeeklyTaskReportForm from "./components/WeeklyTaskReportForm";
import QuizPage from "./components/NRQuiz/QuizPage";
import LandingPage from "./components/LandingPage/LandingPage";
import LiveResult from "./components/AttendancePoll/LiveResultPage/LiveResult";
import CastPollForm from "./components/AttendancePoll/CastPoll/CastPollForm";
import WORKersLeadManagement from "./components/WORKersLead/WORKersLeadManagement";
import CustomSnackBar from "./components/CustomComponents/CustomSnackBar";
import CastVoteForm from "./components/AttendancePoll/CastVote/CastVoteForm";
import WORKersTask from "./components/Tasks/WORKersTask/WORKersTask";
import TrainingProgram from "./components/Training/Program/TrainingProgram";
import RegistrationForm from "./components/WORKersManagement/RegistrationForm/RegistrationForm";
import ASK_Allama from "./components/ASKAllama/ASK_Allama";
import TrainingDashboard from "./components/Training/TrainingDashboard";
import PrivacyPolicy from "./components/PrivacyPolicy";
// import RegistrationForm from "./components/WORKersManagement/RegistrationForm/RegistrationForm";
function App() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/firebase-messaging-sw.js').then((registration) => {
			console.log('Service Worker registered:', registration)
		}).catch((err) => {
			console.log('Service Worker registration failed:', err);
		});

	}
	return (
		<>
			<div>
				<BrowserRouter>
					<Routes>
						<Route
							path="/dsf"
							element={<DistrictSelectionForm></DistrictSelectionForm>}
						></Route>
						{/* <Route path="/adminDashboard" element={<Dashboard></Dashboard>}></Route> */}
						<Route path="/Login" element={<LoginScreen></LoginScreen>}></Route>
						<Route path="/" element={<HomePage />}></Route>
						<Route path="/report-login" element={<ReportLoginForm />}></Route>
						<Route path="/signup" element={<ReportSignup />}></Route>
						<Route path="/reportForm" element={<ReportForms />}></Route>
						<Route path="/ask-allama" element={<ASK_Allama />}></Route>
						{/* <Route path="/dashboard" element={<ReportDashboard />}></Route> */}
						<Route
							path="/dashboard"
							element={<LandingPage></LandingPage>}
						></Route>
						<Route
							path="/one-time-task"
							element={<OneTimeTaskReportForm />}
						></Route>
						<Route
							path="/monthly-task"
							element={<NewMonthlyTaskReportForm />}
						></Route>
						<Route
							path="/weekly-task"
							element={<WeeklyTaskReportForm />}
						></Route>
						<Route path="/daily-task" element={<DailyTaskReportForm />}></Route>
						<Route
							path="/content-sheet"
							element={<DailyTaskContentSheet />}
						></Route>
						<Route path="/leads" element={<NewLeads />}></Route>
						<Route
							path="/shareReferral"
							element={<ShareReferralForm />}
						></Route>
						<Route
							path="/missingTasks"
							element={<MissingDailyTasks></MissingDailyTasks>}
						></Route>
						<Route
							path="/NRQuiz"
							element={<QuizPage></QuizPage>}
						></Route>
						<Route
							path="/PollResult/:id/:logo"
							element={<LiveResult></LiveResult>}
						></Route>
						{/* <Route
							path="/PollResult/:id"
							element={<LiveResult></LiveResult>}
						></Route> */}
						<Route
							path="/castpoll/id/:id"
							element={<CastPollForm ></CastPollForm>}
						></Route>
						<Route
							path="/castvote/id/:id"
							element={<CastVoteForm ></CastVoteForm>}
						></Route>
						<Route path="/WORKersleads" element={<WORKersLeadManagement />}></Route>
						<Route path="/WORKersTask" element={<WORKersTask />}></Route>
						<Route path="/register" element={<RegistrationForm />}></Route>
						<Route path="/training" element={<TrainingDashboard />}></Route>
						<Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
					</Routes>
					<CustomSnackBar />
				</BrowserRouter>
			</div>
		</>
	);
}

export default App;
